// deps
import React, { memo } from "react";

// types
import { ISuccessBanner } from "@dineout-payment-success-ui/interfaces";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styles
import {
    BillClearedText,
    DividingLine,
    SuccessBannerWrapper,
    TotalAmountText,
    AmountTextWrapper,
    StyledText,
} from "./styles";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// constants
import { SUCCESS_BANNER_TEXTS } from "@dineout-payment-success-ui/constants/SuccessBanner";
import { SacramentoFont } from "@dineout-payment-success-ui/constants/Constants";

// helpers
import { format } from "@swiggy-private/core-ui";

// test-ids
import { PAYMENT_SUCCESS_BANNER } from "@swiggy-private/payment-test-ids";
import { BgContainer } from "@dineout-payment-success-ui/components/dineout-payment-success/styles";

const SuccessBanner: React.FC<ISuccessBanner> = ({
    totalAmount,
    paidAmount,
    subscriptionValue,
    tip,
    styles,
    backgroundImage,
}) => {
    return (
        <SuccessBannerWrapper>
            <SacramentoFont />
            <BgContainer>
                <Image src={backgroundImage ?? ""} height="450px" />
            </BgContainer>
            <AmountTextWrapper>
                <BillClearedText colorCode={styles?.billClearedColor}>
                    {SUCCESS_BANNER_TEXTS.BILL_CLEARED}
                </BillClearedText>
                {totalAmount && (
                    <TotalAmountText
                        variant="V2.hero.neutral.bold"
                        data-testid={PAYMENT_SUCCESS_BANNER.TOTAL_AMOUNT}
                        colorCode={styles?.totalAmountColor}
                    >
                        {format(SUCCESS_BANNER_TEXTS.TOTAL_AMOUNT, totalAmount || "")}
                    </TotalAmountText>
                )}
                <DividingLine />
                {paidAmount && (
                    <Text
                        variant="V2.heading2.neutral.black"
                        color="positive"
                        data-testid={PAYMENT_SUCCESS_BANNER.PAID_AMOUNT}
                        style={styles?.paidByYouTextColor ? { color: styles?.paidByYouTextColor } : {}}
                    >
                        {format(SUCCESS_BANNER_TEXTS.PAID_AMOUNT, paidAmount || "")}
                    </Text>
                )}
                {tip && tip !== 0 ? (
                    <StyledText
                        variant="V2.body2.neutral.medium"
                        color="text_Med_Emphasis"
                        data-testid={PAYMENT_SUCCESS_BANNER.TIP_TEST_IDS}
                    >
                        {format(SUCCESS_BANNER_TEXTS.TIP, `${tip}`)}
                    </StyledText>
                ) : null}
                {subscriptionValue ? (
                    <StyledText
                        variant="V2.body2.neutral.medium"
                        color="text_Med_Emphasis"
                        data-testid={PAYMENT_SUCCESS_BANNER.SUBSCRIPTION_VALUE}
                    >
                        {format(SUCCESS_BANNER_TEXTS.SUBSCRIPTION, `${subscriptionValue}`)}
                    </StyledText>
                ) : null}
            </AmountTextWrapper>
        </SuccessBannerWrapper>
    );
};

export default memo(SuccessBanner);
